module.exports = __webpack_public_path__ + "static/media/nestingdesign-IG-2.06ad93c2.PNG";